import {
  EMAIL_HEADING_BLOCKSHEADING_DATA_URI,
  EMAIL_HEADING_CTATITLE_DATA_URI,
  EMAIL_HEADING_PILOTTITLE_DATA_URI,
  EMAIL_HEADING_READINESSHEADING_DATA_URI,
  EMAIL_HEADING_TITLE_DATA_URI,
} from './checklistSalesEmailHeadingAssets';

/** Статические PNG-заголовки (Even Mono) для письма. Баллы и бейдж — HTML в шаблоне. */
export function getStaticChecklistSalesEmailHeadingImages() {
  return {
    title: EMAIL_HEADING_TITLE_DATA_URI,
    blocksHeading: EMAIL_HEADING_BLOCKSHEADING_DATA_URI,
    readinessHeading: EMAIL_HEADING_READINESSHEADING_DATA_URI,
    ctaTitle: EMAIL_HEADING_CTATITLE_DATA_URI,
    pilotTitle: EMAIL_HEADING_PILOTTITLE_DATA_URI,
  };
}

/**
 * Заголовки письма: статические PNG + HTML для score/badge (без html2canvas).
 * @param {object} _emailData — сохранено для совместимости вызова из ChecklistPage
 */
export async function buildChecklistSalesEmailHeadingImages(_emailData) {
  return getStaticChecklistSalesEmailHeadingImages();
}
